import './foundation';
import "./index.css";

import moment from 'moment';
moment.locale("de");

// Is this still necessary?
const Rails = require('@rails/ujs');
Rails.start();
